import { render, staticRenderFns } from "./RegistrationsDialog.vue?vue&type=template&id=2b51790d&scoped=true"
import script from "./RegistrationsDialog.vue?vue&type=script&lang=js"
export * from "./RegistrationsDialog.vue?vue&type=script&lang=js"
import style0 from "./RegistrationsDialog.vue?vue&type=style&index=0&id=2b51790d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b51790d",
  null
  
)

export default component.exports